import { render, staticRenderFns } from "./content.vue?vue&type=template&id=73616418&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=73616418&prod&lang=scss&scoped=true"
import style1 from "./content.vue?vue&type=style&index=1&id=73616418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73616418",
  null
  
)

export default component.exports